<template>
  <div>
    <div class="header mb-4">
      <h1 class="header-title">Order #{{ $route.params.id }}</h1>
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <a href="#">Dashboard</a>
          </li>
          <li class="breadcrumb-item">
            <a href="#">Orders</a>
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            Order Details
          </li>
        </ol>
      </nav>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body" v-if="!loading">
            <div class="row">
              <div class="col-md-9">
                <button class="btn btn-info float-end">
                  Status: {{ order.status }}
                </button>
                <h4>Order Details</h4>
                <hr />
                <div class="row">
                  <div class="col-md-6">
                    <label>Content Type</label>
                    <p>{{ order.type.name }}</p>
                  </div>
                  <div class="col-md-6">
                    <label>Content Category</label>
                    <p>{{ order.category.name }}</p>
                  </div>
                  <div class="col-md-12">
                    <label>Title</label>
                    <p>{{ order.title }}</p>
                  </div>
                  <div class="col-md-12">
                    <label>Instructions</label>
                    <p>{{ order.instructions }}</p>
                  </div>
                  <div class="col-md-12" v-if="order.examples.length > 0">
                    <label>Examples</label>
                    <div class="row">
                      <div
                        class="col-md-6"
                        v-for="(example, i) in order.examples"
                        :key="`example-${i}`"
                      >
                        <p>{{ example }}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="order.status == 'review'">
                  <hr />
                  <h4>Order Pending Your Review</h4>
                  <p>
                    Document:
                    <a
                      :href="order.assignment.document"
                      target="_blank"
                      class="btn btn-secondary ms-2"
                      ><i class="fal fa-download"></i>Download</a
                    >
                  </p>
                  <p>Completed On: {{ order.assignment.completed_at }}</p>
                  <div>
                    <a
                      href="#"
                      class="btn btn-primary"
                      @click.prevent="complete"
                      ><i class="fal fa-save"></i>Mark As Complete</a
                    >
                    <a
                      href="#"
                      class="btn btn-warning float-end"
                      @click.prevent="show_return = true"
                      ><i class="fal fa-save"></i>Return order for changed</a
                    >
                  </div>
                </div>
                <div v-if="order.status == 'complete'">
                  <hr />
                  <h4>Your Order Is Complete</h4>
                  <p>
                    Document:
                    <a
                      :href="order.assignment.document"
                      target="_blank"
                      class="btn btn-secondary ms-2"
                      ><i class="fal fa-download"></i>Download</a
                    >
                  </p>
                  <p>Completed On: {{ order.assignment.completed_at }}</p>
                </div>
                <hr />
                <div>
                  <h4>Timeline and Notes</h4>
                  <section class="py-2">
                    <ul class="timeline">
                      <li class="timeline-item mb-5" v-for="(line, i) in order.timeline" :key="`line-${i}`">
                        <h5 class="fw-bold">{{ line.title }}</h5>
                        <p class="text-muted mb-2 fw-bold">{{ line.date }}</p>
                        <p class="text-muted">{{ line.message }}</p>
                        <p class="text-muted" v-if="line.penalty > 0">Penalty: KES{{ line.penalty }}</p>
                      </li>
                    </ul>
                  </section>
                </div>
              </div>
              <div class="col-md-3">
                <div class="card shadow">
                  <div class="card-body">
                    <h4><i class="far fa-shopping-cart"></i> My Order</h4>
                    <hr />
                    <div>
                      <p class="mb-0">
                        <strong class="me-2">Quality:</strong>
                        <quality :quality="order.quality" />
                      </p>
                      <p>{{ order.quality.name }}</p>
                    </div>
                    <div>
                      <p class="mb-0">
                        <strong class="me-2">Word Count:</strong>
                      </p>
                      <p>Min: {{ order.min }}, Max: {{ order.max }}</p>
                    </div>
                    <div>
                      <p class="mb-0">
                        <strong class="me-2">Created:</strong>
                      </p>
                      <p>{{ order.created_at }}</p>
                    </div>
                    <hr />
                    <div>
                      <h3>Total: ${{ order.price }}</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <loading v-if="loading" />
        </div>
      </div>
    </div>
    <modal :show="show_return" @close="show_return = false">
      <template slot="header">Return Order for changes</template>
      <form @submit.prevent="returnOrder" id="return-form">
        <div class="mb-3">
          <label>Message</label>
          <textarea
            name="message"
            v-model="message"
            placeholder="Message"
            rows="4"
            class="form-control"
          ></textarea>
        </div>
        <div class="mb-3">
          <button class="btn btn-primary">
            <i class="fa fa-save"></i>Proceed
          </button>
        </div>
      </form>
    </modal>
  </div>
</template>

<script>
export default {
  mounted() {
    this.fetch();
  },

  data() {
    return {
      order: {},
      loading: true,
      show_return: false,
      message: null
    };
  },

  methods: {
    fetch() {
      this.loading = true;

      this.$axios
        .get(`/api/v1/dashboard/orders/${this.$route.params.id}`)
        .then((response) => {
          this.order = response.data.order;
          this.loading = false;
        });
    },

    complete() {
      this.loading = true;

      let data = {
        action: 'complete'
      }

      this.$axios
        .put(`/api/v1/dashboard/orders/${this.$route.params.id}`, data)
        .then(() => {
          this.loading = false;
          this.fetch()
        });
    },

    returnOrder() {
      let data = {
        form_id: "return-form",
        message: this.message,
        action: "return",
      };

      this.$axios
        .put(`/api/v1/dashboard/orders/${this.$route.params.id}`, data)
        .then(() => {
          this.show_return = false;
          this.fetch();
        });
    }
  },
};
</script>
